import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../shared/services/http.service";
import { ControllerService } from "../shared/services/controller.service";
import { Router } from "@angular/router";
import { DialogInputComponent } from "../dialog-input/dialog-input.component";

@Component({
  selector: "app-tag-management",
  templateUrl: "./tag-management.component.html",
  styleUrls: ["./tag-management.component.scss"],
  standalone: false
})
export class TagManagementComponent implements OnInit, AfterViewInit {
  tags: any[] = [];
  dataSource: any;

  displayedColumns = ['tag', 'clients', 'users', 'reports', 'actions'];

  page = 0;
  size = 20;
  count = 0;

  filterValue = '';
  filterDebounce: any;

  deletingTag: any = null;
  deleteConfirmName = '';

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private httpService: HttpService,
    private controller: ControllerService,
    private router: Router,
    private modalService: NgbModal
  ) {}


  get deleteConfirmValid(): boolean {
    return this.deletingTag && this.deleteConfirmName === this.deletingTag.tag;
  }

  positionPopover(popoverId: string, event: MouseEvent) {
    const btn = event.currentTarget as HTMLElement;
    const rect = btn.getBoundingClientRect();
    const el = document.getElementById(popoverId);
    if (el) {
      el.style.top = `${rect.bottom + 4}px`;
      el.style.left = `${rect.right - 160}px`;
    }
  }

  filter(event: any) {
    this.filterValue = event.target.value;
    if (this.filterDebounce) clearTimeout(this.filterDebounce);
    this.filterDebounce = setTimeout(() => {
      this.page = 0;
      this.fetchTags();
    }, 250);
  }

  async fetchTags() {
    const sort = this.sort
      ? { active: this.sort.active, direction: this.sort.direction }
      : {};
    const res: any = await this.httpService.postAsync('htag/detailedList', {
      page: this.page,
      size: this.size,
      filter: this.filterValue,
      sort
    });
    this.tags = res?.data || [];
    this.count = res?.count || 0;
    this.dataSource.data = this.tags;
  }

  onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.fetchTags();
  }

  async createTag() {
    try {
      const modalRef = this.modalService.open(DialogInputComponent, {
        windowClass: 'center-modal-window'
      });
      modalRef.componentInstance.message = 'Create a new tag';
      modalRef.componentInstance.placeholder = 'Tag name';
      const name = await modalRef.result;
      if (name) {
        await this.httpService.postAsync('htag/create', { tag: name });
        await this.fetchTags();
      }
    } catch (_) {}
  }

  async renameTag(tag: any, event: MouseEvent) {
    event.stopPropagation();
    // close any open popovers
    document.querySelectorAll('[popover]').forEach((el: any) => el.hidePopover?.());
    try {
      const modalRef = this.modalService.open(DialogInputComponent, {
        windowClass: 'center-modal-window'
      });
      modalRef.componentInstance.message = `Rename tag <strong>${tag.tag}</strong>`;
      modalRef.componentInstance.value = tag.tag;
      modalRef.componentInstance.placeholder = 'Tag name';
      const newName = await modalRef.result;
      if (newName && newName !== tag.tag) {
        await this.httpService.postAsync('htag/update', { tagId: tag.id, tag: newName });
        await this.fetchTags();
      }
    } catch (_) {}
  }

  startDelete(tag: any, event: MouseEvent) {
    event.stopPropagation();
    document.querySelectorAll('[popover]').forEach((el: any) => el.hidePopover?.());
    this.deletingTag = tag;
    this.deleteConfirmName = '';
  }

  cancelDelete(event?: MouseEvent) {
    if (event) event.stopPropagation();
    this.deletingTag = null;
    this.deleteConfirmName = '';
  }

  async confirmDelete() {
    if (!this.deleteConfirmValid) return;
    await this.httpService.postAsync('htag/delete', { tagId: this.deletingTag.id });
    this.deletingTag = null;
    this.deleteConfirmName = '';
    await this.fetchTags();
  }

  gotoReport(tagId: string, type: string, event: MouseEvent, tagName?: string) {
    event.stopPropagation();
    document.querySelectorAll('[popover]').forEach((el: any) => el.hidePopover?.());
    if (type === 'completion') {
      this.router.navigate([`client/${tagName}/report`], { queryParams: { tagId } });
      return;
    }
    if (type === 'actions') {
      this.router.navigate([`client/${tagName}/actions`], { queryParams: { tagId } });
      return;
    }
    const routes: Record<string, any[]> = {
      feedback:    ['/shared-reflections'],
      reflections: ['/shared-reflections'],
    };
    this.router.navigate(routes[type] ?? ['client/_ALL_/report'], { queryParams: { tagId, tag: tagName } });
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.page = 0;
      this.fetchTags();
    });
  }

  async ngOnInit() {
    this.controller.shiftContainerToTop();
    this.dataSource = new MatTableDataSource(this.tags);
    await this.fetchTags();
  }
}
